// extracted by mini-css-extract-plugin
export default {"verticalIcon":"verticalIcon---mis+"};